module.exports = __webpack_public_path__ + "img/green_arrow.f55a495f.svg";